import Header from './components/Header';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import Services from './components/Services';
import AIAnswerBlock from './components/AIAnswerBlock';
import Process from './components/Process';
import WhyChooseUs from './components/WhyChooseUs';
import MidCTA from './components/MidCTA';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import LeadForm from './components/LeadForm';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <main className="min-h-screen bg-white">
      <Header />
      <Hero />
      <TrustBar />
      <Services />
      <AIAnswerBlock />
      <Process />
      <WhyChooseUs />
      <MidCTA />
      <ServiceAreas />
      <Testimonials />
      <FAQ />
      <FinalCTA />
      <LeadForm />
      <Footer />
    </main>
  );
}
